import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const WhyUs = () => {
  const points = ['une expertise pointue du détatouage', 'une formation continue sur les technologies laser', 'un accompagnement adapté au type de peau', 'une évaluation réaliste des résultats'];
  return <section id="why-us" className="py-40 md:py-56 bg-brand-darker" data-id="element-190">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-191">
        <div className="max-w-6xl mx-auto text-center mb-24 lg:mb-32" data-id="element-192">
          <ScrollReveal blur scale duration={1.2} data-id="element-193">
            <h2 className="text-5xl md:text-7xl lg:text-[6.5rem] font-black text-brand-light mb-10 tracking-tighter leading-[1.02] text-balance" data-id="element-194">
              Pourquoi Choisir Dispel Your Tattoo pour votre Détatouage en
              Valais ?
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.2} blur data-id="element-195">
            <h3 className="text-2xl md:text-3xl font-medium text-brand-gray tracking-tight" data-id="element-196">
              Expertise, Précision et Approche Personnalisée
            </h3>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-24 lg:mb-32" data-id="element-197">
          {points.map((point, index) => <div key={index} className="relative pt-10" data-id="element-198">
              <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1,
            delay: 0.3 + index * 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="absolute top-0 left-0 w-full h-[1px] bg-brand-border/50 origin-left" data-id="element-199" />
              <ScrollReveal delay={0.4 + index * 0.15} blur direction="none" distance={0} data-id="element-200">
                <span className="text-sm font-black text-brand-light/20 block mb-6 tracking-widest" data-id="element-201">
                  0{index + 1}
                </span>
                <p className="text-xl md:text-2xl text-brand-light font-medium tracking-tight leading-snug" data-id="element-202">
                  {point}
                </p>
              </ScrollReveal>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-203">
          <ScrollReveal delay={0.8} blur direction="up" distance={40} data-id="element-204">
            <p className="text-2xl md:text-4xl text-brand-gray font-light leading-relaxed text-balance" data-id="element-205">
              Mon objectif est de fournir un détatouage sûr, maîtrisé et de
              haute qualité, dans le respect total de votre peau.
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>;
};